<template lang="pug">
span
  custom-number-dialog(
    :value="showSelectCustomNumberDialog"
    @close="showSelectCustomNumberDialog = false"
  )
  sms-compliance-blocked-dialog(
    :value="showSmsComplianceBlockedDialog"
    @close="showSmsComplianceBlockedDialog = false"
  )
  pagination-list-modal(
    v-if="showContactsDialog && isBlockedBySMSRates"
    v-model="showContactsDialog"
    :items="notOptedInContacts.slice(skip, skip + limit)"
    :total="notOptedInContacts.length"
    :limit="limit"
    :skip="skip"
    title="Contacts not opted in"
    description="Here's some of the contacts we found that are missing consent proof. Get started by selecting one to add it!"
    @close="closeContactsDialog"
    @setPage="setContactsPage"
    @setPageLimit="setContactsPageLimit")
      template(slot="items" slot-scope="{ item }")
        v-layout(row)
          div
            a(@click.prevent="contactRoute(item)").pr-1 {{displayContact(item)}}
  liondesk-dialog(
      v-model="showBulkTextsWarningModal"
      dialogTitle="Start Campaign"
      okButtonText="Edit Campaign"
      cancelButtonText="Go back"
      @click:ok="handleGoToCampaigns"
      @click:cancel="handleGoBack"
    )
      v-layout(slot="body" column)
        v-card-text To safeguard your custom number's reputation with carriers, mass texting is not supported in LionDesk.
        v-card-text To continue using your campaigns please remove the texting actions in your campaign.
  span(@click="modal_open")
    slot(name="activator")
  v-dialog.d-inline(v-model="isModalVisible" lazy persistent :max-width="showSmsConsentReview ? 700 : 480")
    sms-consent-review(
      v-if="showSmsConsentReview"
      @cancel="onCancelSmsConsent"
      @continue="onSmsConsentContinueCampaign"
      :contacts="contactsOptInStatuses"
    )
    v-card(v-else)
      .close-btn-container.mr-2(v-if="isBlockedBySMSRates")
        v-btn.icon-btn.ma-0.pa-0.white-button(flat icon @click="cancel")
          v-icon.ma-0.pa-0(size="25") close
      div(:class="{'pr-5': isBlockedBySMSRates}").primary-color
        title-bar(dark) {{ title }}
      v-progress-linear.my-0(v-if="contactsTableLoading" indeterminate)
      v-card-text
        v-autocomplete(
          solo
          flat
          clearable
          no-filter
          hide-selected
          prepend-inner-icon="search"
          :search-input.sync="search"
          :items="searchItems"
          placeholder="Search campaigns"
          :loading="isLoading"
          item-text="name"
          :item-value="selectedCampaignValue"
          v-model="selectedCampaign"
        )
        div.caption.warning-box(v-if="campaignHasRecurringAction")
          p
            v-icon.pr-1(small) warning
            | This campaign contains at least one action with an unsupported timing type. To proceed, you can:
            ul
              li
                a(@click="redirectToCampaignActions") {{ 'Edit the action(s) and change the timing to one of the supported types' }}
              li Select and start another campaign
        div.caption.warning-box.highly-visible.mt-1(v-if="isBlockedBySMSRates")
          v-icon.pr-1(small) warning
          | PLEASE NOTE: Only contacts that have opted in will receive your text messages.
        div.caption.warning-box.highly-visible.mt-1(v-else-if="hasSMSAction && userHasBulkTexts")
          v-icon.pr-1(small) warning
          | PLEASE NOTE: There are SMS messages included in this campaign. Any contacts that have opted out will not receive texts.
      v-card-actions
        v-spacer
        v-btn(v-if="isBlockedBySMSRates" color='primary' outline @click="openContactsDialog") Add SMS consent
        v-btn(flat @click="cancel" v-else) Cancel
        v-btn.primary.ld-gated-feature(
          v-if="isBlockedFromTexting"
          slot="activator"
          :disabled="!selectedCampaign"
          @click="showSmsComplianceBlockedDialog = true"
        ) Start Campaign
        v-btn.primary.ld-gated-feature(
          v-else-if="isBlockedByBulkTexting"
          slot="activator"
          :disabled="!selectedCampaign"
          @click="openBulkTextWarningModal"
        ) Start Campaign
        v-btn.primary.ld-gated-feature(
          v-else-if="showCustomNumberBtnCase"
          slot="activator"
          @click="showSelectCustomNumberDialog = true"
        ) Start Campaign
        v-btn.primary.ld-gated-feature(
          v-else-if="show10DLCBtnCase"
          slot="activator"
          @click="onPending10DLCSend()"
        ) Start Campaign
        v-btn.primary.ld-gated-feature(
          v-else-if="isBlockedFromStartingCampaignWithTexts"
          slot="activator"
          disabled="true"
        ) Start Campaign
        v-btn.primary(
          v-else-if="!hasLeadAssistAction"
          @click="save" 
          :disabled="!selectedCampaign"
          ) Start Campaign
        v-btn.primary(
          v-else-if="hasLeadAssistAction"
          :feature="LdFeatures.LeadAssist"
          :disabled="!selectedCampaign"
          @click="save"
          :usage="selectedIds.length"
        ) Start Campaign
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import Modal from '@/Core/mixins/modal';
import { debounce } from '@/Core/utilities';
import { LdGatedButton, LdFeatures } from 'lion-vue';
import SmsConsentReview from '@/Contacts/components/actions/SmsConsentReview';
import { GATED_ACTIONS } from '@/Core/config/gated-actions';
import sendSMSGate from '@/Core/mixins/send-sms-gate';
import { REGISTRATION_STATES } from '../../../Text/config/registrationStatus';
import { EventBus } from '@/event-bus';
import { STEPS_SOLE_PROPRIETOR } from '@/a2p/config';
import { soleProprietor } from '@/Text/config/consoleSteps';
import PaginationListModal from '@/Core/components/PaginationListModal'
import {
  ES_STATUS
} from '@/Contacts/config/profile-optin-status'

const LEAD_ASSIST_TYPE = 'LionDesk Lead Assist (TM)';
const LEAD_ASSIST_TYPE_ID = 13;
const TEXT_CONTACT_TYPE = 'Text Contact';
const TEXT_CONTACT_TYPE_ID = 3;
const solePropCloseAction = 'campaign';

const {
  mapState: mapContactsSearchCampaignState,
  mapGetters: mapContactSearchCampaignGetters,
  mapActions: mapContactSearchCampaignActions,
} = createNamespacedHelpers('contactsSearchCampaign');

const { mapState: mapContactsTableState } = createNamespacedHelpers('contactsTable');

const { mapActions: mapContactsTableBulkActionActions } = createNamespacedHelpers(
  'contactsTable/bulkActions',
);

const { mapState: mapGetActionState, mapActions: mapGetActionActions } =
  createNamespacedHelpers('getAction');

const { mapState: mapUserInformationState, mapGetters: mapUserInformationGetters } =
  createNamespacedHelpers('userInformation');

const { mapState: mapConversationsState, mapActions: mapConversationsActions } =
  createNamespacedHelpers('conversations');

const {
  mapActions: mapSoleProprietorActions,
  mapState: mapSoleProprietorState,
} = createNamespacedHelpers('registerSoleProprietorA2p');

const { mapState: mapUserSmsErrorRatesState, mapActions: mapUserSmsErrorRatesActions } = createNamespacedHelpers(
  'userSmsErrorRates',
);

const { mapActions: mapContactsTableActions } = createNamespacedHelpers(
  'contactsTable',
);

export default {
  components: {
    TitleBar,
    LdGatedButton,
    SmsConsentReview,
    LiondeskDialog,
    CustomNumberDialog: () =>
      import(/* webpackChunkName: 'CustomNumberDialog' */ '@/Core/components/CustomNumberDialog'),
    SmsComplianceBlockedDialog: () =>
      import(/* webpackChunkName: 'SmsComplianceBlockedDialog' */ '@/Core/components/SmsComplianceBlockedDialog'),
    PaginationListModal,
  },
  mixins: [Modal, sendSMSGate],
  data() {
    return {
      LdFeatures,
      search: null,
      selectedCampaign: null,
      showError: false,
      hasLeadAssistAction: false,
      hasSMSAction: false,
      showSmsConsentReview: false,
      gatedActions: GATED_ACTIONS,
      showSelectCustomNumberDialog: false,
      showBulkTextsWarningModal: false,
      showContactsDialog: false,
      limit: 15,
      skip: 0,
      page: 1,
      notOptedInContacts: [],
      showSmsComplianceBlockedDialog: false,
    };
  },
  created() {
    EventBus.$on('sole-prop-modal-close', data => {
      if (data === solePropCloseAction && this.canSendSMS) {
        this.save()
      }
    });
  },
  async mounted() {
    await this.getRates();
    if (!this.has10dlcRegister || this.isRegistration10dlcIncomplete) {
      await this.checkFor10dlcRegister();
    }
  },
  computed: {
    ...mapSoleProprietorState(['showRegisterSoleProprietorModal', 'registrationModalClose']),
    ...mapContactsSearchCampaignState(['isLoading']),
    ...mapContactSearchCampaignGetters(['searchItems']),
    ...mapContactsTableState({
      contactsTableLoading: state => state.isLoading,
      campaignHasRecurringAction: state => state.bulkActions.campaignHasRecurringAction,
      campaignInProgress: state => state.bulkActions.inProgress,
      startCampaignError: state => state.bulkActions.startCampaignError,
    }),
    ...mapGetActionState(['actions']),
    ...mapUserInformationState(['user']),
    ...mapUserInformationGetters(['shouldGoToLeadsPlusFlow', 'hasAccessToFeature', 'userHasFeatureFlag']),
    ...mapConversationsState([
      'hasNonApproved', 
      'contactsOptInStatuses', 
      'registrationStatus10dlc', 
      'registrationDate10dlc', 
      'registrationType10dlc',
      'isLeadsPlusUser',
      'has10dlcRegister',
      'isRegistration10dlcIncomplete',
    ]),
    ...mapUserSmsErrorRatesState([
      'isBlocked',
    ]),
    title() {
      if (this.selectedIds.length === 1) {
        return 'Start Campaign for Contact';
      }
      return `Start Campaign for ${this.totalContactsSelected} Contacts`;
    },
    // simplify after Aug 31
    canSendSMS() {
      const limitDate = new Date(2023, 8, 1);
      if (new Date() > limitDate) {
        return this.registrationStatus10dlc === 'campaign_completed';
      }
      const targetDate = new Date(Date.UTC(2023, 6, 20)); // July 20, 2023
      targetDate.setUTCHours(0, 0, 0, 0);
      const userCreatedAt = Date.parse(this.user.created_at);
      return new Date(userCreatedAt) < targetDate;
    },
    show10DLCBtnCase() {
      return this.hasSMSAction && this.gatedAction === this.gatedActions.Register10DLC;
    },
    showCustomNumberBtnCase() {
      return this.hasSMSAction && this.gatedAction === this.gatedActions.SetCustomNumber;
    },
    isBlockedFromStartingCampaignWithTexts() {
      return this.hasSMSAction && this.gatedAction === this.gatedActions.Blocked;
    },
    isBlockedFromTexting() {
      return this.hasSMSAction && this.gatedAction === this.gatedActions.ComplianceViolationBlocked;
    },
    userHasBulkTexts() {
      return this.hasAccessToFeature(LdFeatures.BulkTexts);
    },
    isBlockedByBulkTexting() {
      return this.hasSMSAction && !this.userHasBulkTexts;
    },
    isBlockedBySMSRates() {
      return this.totalContactsSelected > 1 && this.hasSMSAction && this.userHasBulkTexts && this.isBlocked;
    },
  },

  props: {
    startCampaigns: {
      type: Function,
    },
    selectedIds: {
      type: Array,
    },
    query: {
      type: Object,
    },
    totalContactsSelected: {
      type: Number,
    },
  },

  watch: {
    /**
     * Watcher on the search value.
     * @param  {String} value the search string
     */
    search(search) {
      debounce(this.prepareRequest, [search, this.findCampaigns]);
    },
    selectedCampaign: {
      async handler(currentCampaign, prevCampaign) {
        this.hasSMSAction = false;
        if (currentCampaign) {
          const query = {
            $limit: null,
            action_type_id: { $in: [TEXT_CONTACT_TYPE_ID, LEAD_ASSIST_TYPE_ID] }
          }
          await this.findActions({ id: currentCampaign.id, query });
          this.hasLeadAssistAction = !!this.actions.find(action => {
            return action.type === LEAD_ASSIST_TYPE;
          });
          this.hasSMSAction = this.campaignHasTextContactAction();
        }
        if (!currentCampaign || (prevCampaign && prevCampaign.id !== currentCampaign.id)) {
          this.setCampaignHasRecurringAction({ status: false });
        }
      },
      deep: true,
    },
    async isModalVisible(value) {
      if (!value || !this.selectedIds) return;
      // there's no point in querying all of the contacts
      const queryParams = { id: { $in: this.selectedIds }, $limit: 100 };
      const selectedContactsFilter = await this.findSelectedContacts(queryParams);
      this.notOptedInContacts = selectedContactsFilter.filter(item => item.opt_in_status && item.opt_in_status !== ES_STATUS.approved && item.opt_in_status !== ES_STATUS.denied);
    },
  },
  methods: {
    ...mapContactSearchCampaignActions(['findCampaigns']),
    ...mapContactsTableBulkActionActions(['setCampaignHasRecurringAction']),
    ...mapGetActionActions(['findActions']),
    ...mapConversationsActions(['checkContactsOptInStatuses', 'checkFor10dlcRegister']),
    ...mapSoleProprietorActions(['setShowRegistrationFlowModal', 'setStep']),
    ...mapUserSmsErrorRatesActions(['getRates']),
    ...mapContactsTableActions(['findSelectedContacts']),
    redirectToCampaignActions() {
      this.$router.push({
        name: 'campaigns-show',
        params: { id: this.selectedCampaign.id },
      });
    },
    selectedCampaignValue(campaign) {
      return { id: campaign.id, name: campaign.name };
    },
    async save() {
      await this.startCampaign(this.selectedIds, false);
    },
    async startCampaign(contactIds, skipQueryBuild) {
      const campaignRequest = {
        action: {
          type: 'create',
          resource: 'campaign',
          payload: {
            id: this.selectedCampaign.id,
            name: this.selectedCampaign.name,
          },
        },
        selected: contactIds,
        skipQueryBuild,
      };
      await this.startCampaigns(campaignRequest);
      if (!this.startCampaignError) {
        this.$emit('deselect-all');
        this.$emit('contact-updated');
        this.selectedCampaign = null;
        this.modal_close();
      }
    },
    cancel() {
      this.selectedCampaign = null;
      this.setCampaignHasRecurringAction({ status: false });
      this.modal_close();
    },
    prepareRequest(search, callback) {
      if (typeof callback !== 'function') {
        console.error('Callback is not a function');
      } else {
        callback(search);
      }
    },
    campaignHasTextContactAction() {
      return this.actions.some(action => {
        return action.type === TEXT_CONTACT_TYPE;
      });
    },
    async onSmsConsentContinueCampaign(selectedContactIds) {
      this.showSmsConsentReview = false;
      await this.startCampaign(selectedContactIds, true);
    },
    onCancelSmsConsent() {
      this.showSmsConsentReview = false;
    },
    async onPending10DLCSend() {
      if (!this.registrationStatus10dlc) {
        this.setStep(STEPS_SOLE_PROPRIETOR.DECISION);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        return;
      }

      if (this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_COMPLETED) {
        this.showShortCodeEditor({ action: 'Create' });
        return;
      }

      if (this.shouldGoToLeadsPlusFlow && this.isLeadsPlusUser) {
        this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
        this.setShowRegistrationFlowModal({ bool: true, action: null });
        return;
      }

      if (
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_PENDING ||
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_CAMPAIGN_RETRY_PENDING ||
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_BRAND_RETRY_PENDING
      ) {
        this.setStep(STEPS_SOLE_PROPRIETOR.PAYMENT);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        return;
      }

      if (
        this.canSendSMS && (
          this.registrationStatus10dlc === REGISTRATION_STATES.BRAND_SUBMITTED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_RECEIVED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_SUBMITTED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_PENDING)
      ) {
        return this.save();
      }

      this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
      this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
    },
    openBulkTextWarningModal() {
      this.modal_close();
      this.showBulkTextsWarningModal = true;
    },
    handleGoToCampaigns() {
      this.showBulkTextsWarningModal = false;
      this.redirectToCampaignActions();
    },
    handleGoBack() {
      this.showBulkTextsWarningModal = false;
      this.modal_open();
    },
    contactRoute(item) {
      this.$router.push({ name: 'contact-profile', params: { id: item.id }, hash: '#consent'});
    },
    openContactsDialog() {
      this.showContactsDialog = true;
    },
    closeContactsDialog() {
      this.showContactsDialog = false;
    },
    setContactsPage(page) {
      this.page = page;
      this.skip = (page - 1) * this.limit;
    },
    setContactsPageLimit(limit) {
      this.limit = limit;
      this.setContactsPage(1)
    },
    displayContact: item => {
      const phone = item.mobile_phone || item.phone_mobile || '';
      if (item.first_name && item.last_name) {
        return `${item.first_name || ''} ${item.last_name || ''} (${phone})`;
      }
      return phone;
    },
  },
};
</script>

<style lang="scss" scoped>
.highly-visible {
  color: var(--v-secondary-darken3);
  border: 1px solid var(--v-error-darken1);
}

.close-btn-container {
  position: absolute;
  right: 0;
  margin-top: 10px;
}

.primary-color {
  background-color: var(--v-primary-base);
}

.white-button {
  color: white;
}
</style>
